import { DiContainer } from '@/modules/di/di-container';
import { createEffect, createEvent, createStore, sample } from 'effector';
import { BusinessOffersService } from '../services/business-offers.service';
import { IIncomingOffer, ITradeGroup, offersSort } from '../types/business-offer';

const businessOffersService = DiContainer.get(BusinessOffersService);

type LoadingStatus = {
  loading: boolean;
  error: Error | null | boolean;
};

export const setTradeOffers = createEvent<any>();
export const setLoadingStatus = createEvent<LoadingStatus>();
export const $tradeOffers = createStore<IIncomingOffer[]>([]).on(
  setTradeOffers,
  (_state, payload) => payload,
);
export const $tradeOffersLoadingState = createStore<LoadingStatus>({
  loading: false,
  error: false,
});

export const fetchTradeOffersFx = createEffect(async (sort?: offersSort) => {
  const data: any = await businessOffersService.getAllBusinesOffers(sort);
  return data.map((item: any) => ({
    ...item,
    selected: false,
    expired: false,
    remainingMinutes: null,
  }));
});

sample({ target: $tradeOffers, clock: fetchTradeOffersFx.doneData });

// $tradeOffersLoadingState
//   .on(fetchTradeOffersFx.done, () => ({ loading: false, error: false }))
//   .on(fetchTradeOffersFx.pending, () => ({ loading: true, error: false }))
//   .on(fetchTradeOffersFx.failData, (_s, p) => ({ loading: false, error: p }));

$tradeOffersLoadingState.on(setLoadingStatus, (state) => state);

fetchTradeOffersFx.pending.watch((pending) => {
  pending && setLoadingStatus({ loading: true, error: false });
});

fetchTradeOffersFx.done.watch(() => {
  setLoadingStatus({ loading: false, error: false });
});

fetchTradeOffersFx.fail.watch(({ error }) => {
  setLoadingStatus({ loading: false, error: error });
});

// ===========

export const $approvedTradesGroups = createStore<ITradeGroup[] | null>(null);
export const $approvedTradesGroupsLoadingStatus = createStore<LoadingStatus>({
  loading: false,
  error: false,
});
const setApprovedTradesGroups = createEvent();
const setApprovedTradesLoadingStatus = createEvent<LoadingStatus>();
$approvedTradesGroups.on(setApprovedTradesGroups, (_s, p) => p);
$approvedTradesGroupsLoadingStatus.on(setApprovedTradesLoadingStatus, (_s, p) => p);

export const fetchApprovedTradesGroupsListFx = createEffect(async () => {
  try {
    setApprovedTradesLoadingStatus({ loading: true, error: false });
    const data = await businessOffersService.getApprovedTradesGroups();
    setApprovedTradesLoadingStatus({ loading: false, error: false });
    return data;
  } catch (err) {
    setApprovedTradesLoadingStatus({ loading: false, error: err as Error });
  }
});

sample({
  target: setApprovedTradesGroups,
  clock: fetchApprovedTradesGroupsListFx.doneData,
});

// =========

export const finishOrdersListFx = createEffect(async (idsList: number[]) => {
  try {
    const data = await businessOffersService.finishSelectedOrders(idsList);
    return data;
  } catch (err: any) {
    if (err.headers) {
      throw await err.json();
    }
    throw err
  }
})
